import { render } from "./GalleryCarousel.vue?vue&type=template&id=b34b0b60"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js"

import "./GalleryCarousel.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__